import { ArrowUpRight } from "lucide-react";

const cols = [
  {
    title: "Platform",
    links: ["Features", "Industries", "Process", "Stack"],
  },
  {
    title: "Company",
    links: ["About", "Customers", "Careers", "Contact"],
  },
  {
    title: "Resources",
    links: ["Documentation", "Case Studies", "Security", "Privacy"],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="bg-[#050505] text-white pt-24 pb-10 relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <h3 className="font-display text-xl font-normal mb-6 text-white/60">
              Software should adapt to your business.
            </h3>
            <p className="text-base text-white/70 font-light leading-relaxed max-w-md">
              NOEX builds custom AI-powered operating systems for businesses that
              refuse to be templated.
            </p>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="group mt-8 inline-flex items-center gap-2 bg-white text-black text-sm font-medium px-6 py-3.5 rounded-full hover:bg-white/90 active:scale-95 transition-all duration-300"
            >
              Book Demo
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10">
            {cols.map((c, i) => (
              <div key={i}>
                <h4 className="text-xs tracking-[0.2em] uppercase text-white/40 mb-5">
                  {c.title}
                </h4>
                <ul className="space-y-3">
                  {c.links.map((l, j) => (
                    <li key={j}>
                      <a
                        href="#"
                        className="text-sm text-white/70 hover:text-white transition-colors"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Massive logotype */}
        <div className="py-16 md:py-20 flex items-center justify-center">
          <h2
            data-testid="footer-logotype"
            className="font-display text-[20vw] md:text-[16vw] leading-none font-light tracking-tighter text-white/90 select-none"
          >
            NOEX<span className="text-white/30">.</span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/10">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} NOEX Systems. All rights reserved.
          </p>
          <p className="text-xs tracking-[0.2em] uppercase text-white/40">
            Custom-built · Secure · Production-grade
          </p>
        </div>
      </div>
    </footer>
  );
}
